import { render, staticRenderFns } from "./MenuContent.vue?vue&type=template&id=116f41cc"
import script from "./MenuContent.vue?vue&type=script&lang=js"
export * from "./MenuContent.vue?vue&type=script&lang=js"
import style0 from "./MenuContent.vue?vue&type=style&index=0&id=116f41cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports